import { InspectionDetailsPage } from "@/components/inspection/details-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/inspection/$licenseId/")({
  component: InspectionDetailsPage,
});
